export const effects = {

  fadeLeft: (text, opts) => {
    const factor = 200;
    const fade = Math.min(opts.x / factor, 1);
    text.addColor(`rgba(0,0,0,${fade})`, 0);
  },

  fadeRight: (text, opts) => {
    const factor = 400;
    const fade = 1 - Math.min(opts.x / factor, 1);
    text.addColor(`rgba(0,0,0,${fade})`, 0);
  },

  splatter: (text, opts) => {
    text.body.velocity.y = rng(100, 100 + opts.rate);
    text.body.setCircle(text.width);
  },

  squish: (text, opts) => {
    text.body.setRectangle(text.width);
    const acc = opts.y - 100;
    text.body.velocity.y = -rng(acc, acc + opts.rate);
  },

  slantRight: (text, opts) => {
    text.body.setRectangle(4);
    const acc = opts.y + rng(opts.x, opts.x - 50);
    text.body.velocity.y = -rng(acc, acc + opts.rate);
  },

  slantLeft: (text, opts) => {
    text.body.setRectangle(4);
    const acc = opts.y - rng(opts.x, opts.x - 50);
    text.body.velocity.y = -rng(acc, acc + opts.rate);
  },

  /* Right goes down, left goes up */
  splitY: (text, opts) => {
    text.body.setRectangle(4);
    let acc;
    // If we're on the right side, go up
    if (opts.x > opts.width / 2) {
      acc = opts.y + rng(opts.x, opts.x - 50);
    } else {
      acc = opts.y - rng(opts.x, opts.x - 50);
    }
    text.body.velocity.y = -rng(acc, acc + opts.rate);
  },

  /* Top goes up, bottom goes down */
  splitX: (text, opts) => {
    text.body.setRectangle(4);
    let acc = rng(opts.y, opts.y - 50);
    if (opts.y > opts.height / 2) {
      acc = acc;
    } else {
      acc = -acc;
    }
    text.body.velocity.y = acc;
  },

  /* Top goes left, bottom goes right */
  splitRL: (text, opts) => {
    text.body.setRectangle(4);
    let acc = rng(opts.y, opts.y - 50);
    if (opts.y > opts.height / 2) {
      acc = acc;
    } else {
      acc = -acc;
    }
    text.body.velocity.x = acc;
  },

  crossPass: (text, opts) => {
    text.body.damping = rng(0.8, 1.0);
    text.body.setRectangle(1);
    let acc = rng(opts.x / 2.0, opts.x * 1.5);
    if (opts.y > opts.height / 2) {
      acc = -acc;
    } else {
      acc = acc;
    }
    text.body.velocity.y = acc;
  },

  cross: (text, opts) => {
    text.body.damping = rng(0.8, 1.0);
    text.body.setRectangle(text.width);
    let acc = rng(opts.x / 2.0, opts.x * 1.5);
    if (opts.y > opts.height / 2) {
      acc = -acc;
    } else {
      acc = acc;
    }
    text.body.velocity.y = acc;
  },

  crunch: (text, opts) => {
    text.body.setRectangle(4);
    text.body.velocity.x = -rng(200, 200 + opts.rate);
  },

  blob: (text, opts) => {
    text.body.setRectangle(1);
    if (Math.floor(Math.random() * 200) === 0) {
      text.body.setCircle(text.width * 4);
    }
  },

  bullet: (text, opts) => {
    text.body.damping = rng(0.85, 0.95);
    text.body.setRectangle(1);
    if (Math.floor(Math.random() * 200) === 0) {
      text.body.setRectangle(text.width);
      text.body.velocity.x = 300;
      text.body.velocity.y = 300;
      text.body.damping = rng(-10, -1);
    }
  },

  springy: (text, opts) => {
    text.body.setRectangle(4);
    text.body.velocity.x = rng(400, 400 + opts.rate);
  },

  shift: (text, opts) => {
    text.body.velocity.y = -rng(0, 20 + opts.rate);
  },

  spin: (text, opts) => {
    text.body.setRectangle(4);
    text.body.angularVelocity = -rng(-0.2, 0.2);
    text.body.velocity.y = -rng(20, 20 + opts.rate);
  },

  bump: (text, opts) => {
    text.body.velocity.x = rng(-2, 2);
    text.body.velocity.y = rng(-2, 2);
    text.body.setCircle(text.width / 2);
  },

  drift: (text, opts) => {
    text.body.velocity.y = rng(opts.rate, opts.rate * 100);
  }
};

export const sample = arr => {
  return arr[Math.floor(Math.random() * arr.length)];
};

export const rng = (min, max) => {
  return Math.random() * (max - min) + min;
};


//////////////////
// WEBPACK FOOTER
// ./src/effects.js
// module id = 128
// module chunks = 0